import initialState from './initialState';

export const GetUserActivityReducer = {
  pending: (state) => ({
    ...state,
    loading: 'pending',
  }),
  fulfilled: (state, action) => {
    const { list, rowsCount } = action.payload.data;
    return {
      ...state,
      list,
      rowsCount,
      loading: 'succeeded',
    };
  },
  rejected: (state) => ({
    ...state,
    loading: 'failed',
  }),
};

export const ResetUserActivityStateReducer = () => initialState;
